module.exports = "https://cdn.realtymogul.com/static/media/HP_card_riverside.2ea1290e.jpg";